// Media Player: Video
// 

JLM.MD.MediaPlayerVideo = function( container ) {
	
	const INSTANCE = new JLM.MD.MediaPlayer( container );
	
	
	// Variables: Private _______________________________________________________
	
	// References
	let icon_loading, overlay;
	
	
	
	// Constructor ______________________________________________________________
	
	function init() {
		// References
		overlay = $('.jp-overlay', container);
		
		// Events
		overlay.on('click', togglePlay);
		
		// While loading
		icon_loading = JLM.MD.IconLoading( $('.jp-frame', container) );
		
		// jPlayer
		let video_config = {
			m4v: INSTANCE.src
		};
		if ( INSTANCE.poster ) {
			video_config.poster = INSTANCE.poster;
		}
		INSTANCE.media.jPlayer({
			// Attributes
			size: { width: '100%', height: '100%' },
			cssSelectorAncestor: '#' + container.attr('id'),
			useStateClassSkin: true,
			swfPath: '/js/libraries',
			supplied: 'm4v',
			autoBlur: false,
			keyEnabled: true,
			remainingDuration: true,
			toggleDuration: true,
			
			// Events
			ready: function () {
				$(this).jPlayer('setMedia', video_config);
			},
			loadeddata: onLoad,
			play: onPlay,
			pause: onPause
		});
	}
	
	
	
	// Methods: Private _________________________________________________________
	
	// Play or Pause
	// 
	function togglePlay() {
		if ( INSTANCE.media.data('jPlayer').status.paused ) {
			INSTANCE.media.jPlayer('play');
			if ( JLM.mobile ) {
				INSTANCE.media.data('jPlayer')._setOption('fullScreen', true);
			}
		} else {
			INSTANCE.media.jPlayer('pause');
		}
	}
	
	
	// Event: Media data has loaded
	// 
	function onLoad( event ) {
		icon_loading.remove();
		INSTANCE.setDuration( event.jPlayer.status.duration );
		overlay.addClass('loaded');
	}
	
	
	// Event: Video played
	// 
	function onPlay() {
		$('svg.ready', overlay).remove();
		const icon = $('.jp-overlay svg.play').addClass('pulse');
		setTimeout(function() {
			icon.removeClass('pulse');
		}, 600);
	}
	
	
	// Event: Video paused
	// 
	function onPause() {
		const icon = $('.jp-overlay svg.pause').addClass('pulse');
		setTimeout(function() {
			icon.removeClass('pulse');
		}, 600);
	}
	
	
	
	// Initial Setup ____________________________________________________________
	
	init();
	return INSTANCE;
	
};